import { LeaveComponent } from "../../components";

export default function LeaveSummaryPage() {
  return <LeaveComponent.LeaveSummaryList />;
}
